<template>
  <b-row>
    <loader v-if="loading"/>

    <b-col cols="12" md="12" lg="12" class="mb-5">
      <h3>{{$t('resources.block_titles.pricing')}}</h3>

      <div v-if="!loading && noPricing === false"
           :key="$store.getters['resource/currentResource'].key"
           class="white-container">
        <form-fields
            @submit="editResourcePricing"
            :prefill-params="prefillParams"
            :formColumns="12"
            class="px-2"
            :fields="fields"
            :labelBlockWith="6"
            :inline="true"
            :mb="4"
        />
      </div>

      <div class="white-container" v-else-if="!loading && noPricing === true">
        <form-fields
            @submit="attachPricingToResource"
            :formColumns="12"
            class="px-2"
            :fields="attachPlanFields"
            :labelBlockWith="6"
            :inline="true"
            :mb="4"
        />
      </div>
      <div class="white-container py-5" v-else></div>
    </b-col>

    <b-col md="12" v-if="!loadingPartners">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h3 class="mb-0">{{ $t('resources.block_titles.members') }}</h3>
        <b-button @click.prevent="showAddMemberModal = true">{{ $t('resources.button_titles.add_member') }}</b-button>
      </div>

      <v-server-table
          ref="partnersTable"
          class="white-container"
          :url="`/admin/resources/${$route.params.resourceKey}/users/dashboard-access`"
          :columns="columns"
          :options="options"
          @loaded="loading = false"
          @loading="loading = true">
        <template slot="id" slot-scope="props">
          <router-link :to="{path: `/users/edit/${props.row.id}`, params: props.row}" target="_blank">{{props.row.id}}
          </router-link>
        </template>
        <template slot="full_name" slot-scope="props">
          <span class="text-capitaliloadingze">{{props.row.first_name}} {{props.row.last_name}}</span>
        </template>
        <template slot="role" slot-scope="props">
          {{ props.row.role_resource }}
          <b-button
            variant="outline-primary"
            class="border-0 p-1"
            style="height: 34px; width: 34px"
            @click="showEditRoleModal(true, props.row.id, props.row.role_resource)"
        >
          <i class="far fa-edit fa-lg"></i>
        </b-button>
        </template>
      </v-server-table>


      <modal
          :show-modal="showAddMemberModal"
          name="add-member-modal"
          :confirm="$t('button.save')"
          title="Add Member"
          :preventHideOnOk="true"
          @cancel="hideAddMemberModal()"
          @hide="hideAddMemberModal()"
          @ok="addMemberToResource">
        <template slot="body">
          <loader v-if="manipulateMemberLoader"/>
          <b-col>
            <h5>{{ $t('resources.block_titles.member') }}</h5>
            <GetUserForm v-model="addMemberObject" :resource-id="resourceId" />
            <h5>{{ $t('resources.block_titles.role') }}</h5>
            <multiselect v-model="addMemberRole" :options="roleOptions"/>
          </b-col>
        </template>
      </modal>

      <modal
          :show-modal="showRoleModal"
          name="ChooseSubscription"
          :confirm="$t('button.save')"
          title="Change Member Role"
          :preventHideOnOk="true"
          @cancel="showEditRoleModal(false, null, null)"
          @hide="showEditRoleModal(false, null, null)"
          @ok="changePartnerRole(editPartnerId, editPartnerRole)">
        <template slot="body">
          <b-col>
            <multiselect v-model="editPartnerRole" :options="roleOptions"/>
          </b-col>
        </template>
      </modal>
    </b-col>
  </b-row>
</template>


<script>
import GetUserForm from "../../components/forms/user/GetUserForm";
import FormFields from "../../components/global/formFields";
import fields from "./resourcesEditingFields"
import { attachPlanFields } from "./partnersResourceFields";
import i18n from "../../utils/i18n";
import axios from "../../utils/axios";

export default {
  name: "PartnersResourceEdit",
  components: {
    FormFields,
    GetUserForm
  },
  data () {
    return {
      loading: false,
      noPricing: null,
      attachPlanFields: attachPlanFields.items,
      fields: fields.pricing.items,
      addMemberObject: null,
      resourceId: null,
      addMemberRole: 'User',
      manipulateMemberLoader: false,
      loadingPartners: false,
      prefillParams: null,
      editPartnerId: null,
      editPartnerRole: null,
      showAddMemberModal: false,
      showRoleModal: false,
      roleOptions: [
        "Admin", "Readonly", "User"
      ],
      columns: ['id', 'full_name', 'email', 'company', 'role'],
      options: {
        skin: [],
        headings: {
          id: '#',
          full_name: i18n.t('users.full_name'),
          email: i18n.t('users.email'),
          location: i18n.t('users.location'),
          created_at: i18n.t('form.created_at'),
          subscriptions: i18n.t('users.subscription_info'),
          renewal_date: i18n.t('form.renewal_date'),
          actions: i18n.t('global.actions')
        },
        dateColumns: ['created_at'],
        sortable: [],
        clientMultiSorting: false,
        customFilters: ['custom'],
        perPage: !!localStorage.getItem('perPage') && localStorage.getItem('perPage') !== '' ? localStorage.getItem('perPage') : 10,
        filterable: false,
        requestFunction: function (data) {
          let params = {};
          params.limit = data.limit;
          params.filter = data.custom;
          params.page = data.page;

          localStorage.setItem('perPage', data.limit);
          if (!params.filter) {
            params.filter = {};
          }
          // if (params.filter['userresourcerelationships.suspended'] === undefined) {
          //   params.filter['userresourcerelationships.suspended'] = false
          // }
          return axios.get(this.url, {
            params: params
          }).catch((e) => {
            // this.$noty.error(e.error_description);
            this.dispatch('error', e);
          });
        },
        responseAdapter: function (resp) {
          let data = this.getResponseData(resp);
          return {
            data: data.data.items,
            count: data.data.paginator.total_items
          }
        }
      },
    }
  },

  async created () {
    this.loading = true;
    this.resourceId = this.$route.params.resourceKey;
    await this.getPricingPlansOptions();
    await this.getPrefillParams();
    this.loading = false;
  },

  methods: {
    async editResourcePricing (params) {
      const dataParams = {
        ...params,
        monthly_price: this.formatToCents(params.monthly_price),
        transaction_fee: Math.ceil(this.formatToCents(params.transaction_fee)),
        up_free_signups_price: this.formatToCents(params.up_free_signups_price),
        up_free_support_price_per_hour: this.formatToCents(params.up_free_support_price_per_hour),
      }

      await this.putData(`resources/${this.$route.params.resourceKey}/pricing`, dataParams)
          .then((data) => {
            console.log('data', data);
          })
          .catch(error => {
            console.log('create resource error', error)
          })
    },

    async getPricingPlansOptions () {
      return this.getData('pricing/plans')
          .then(({data}) => {
            this.attachPlanFields.forEach(item => {
              if (item.name === 'pricing_plan') {
                item.options = data.items
              }
            });
          })
          .catch(error => {
            console.log('get pricing plans error', error)
          })
    },
    getPrefillParams () {
      return this.getData(`resources/${this.$route.params.resourceKey}/pricing`)
                  .then((response) => {
                    if (response) {
                      if (response.data) {
                        this.prefillParams = {
                          ...response.data,
                          monthly_price: this.formatToDollars(response.data.monthly_price),
                          transaction_fee: this.formatToDollars(response.data.transaction_fee),
                          up_free_signups_price: this.formatToDollars(response.data.up_free_signups_price),
                          up_free_support_price_per_hour: this.formatToDollars(response.data.up_free_support_price_per_hour),
                        }
                      }
                      this.noPricing = false;
                    } else {
                      this.noPricing = true;
                    }

                    return true;
                  })
                  .catch(error => {
                    console.log('ger prefill params error', error)
                  });
    },

    showEditRoleModal (show, id, role) {
      this.showRoleModal = show
      this.editPartnerId = id
      this.editPartnerRole = role
    },

    hideAddMemberModal () {
      this.showAddMemberModal = false;
      this.addMemberObject = null;
      this.addMemberRole = 'User';
    },

    addMemberToResource () {
      if (this.addMemberObject && this.addMemberObject.value) {
        this.changePartnerRole(this.addMemberObject.value, this.addMemberRole).then((data) => {
          this.hideAddMemberModal();
        });
      }
    },

    attachPricingToResource (data) {
      this.postData(`resources/${this.$route.params.resourceKey}/pricing`, {
        pricing_plans_id: data && data.pricing_plan ? data.pricing_plan.id : null
      }).then(async (response) => {
        if (response && response.data && response.data.items) {
          this.loading = true;
          await this.getPrefillParams();
          this.loading = false;
        }
      }).catch((error) => {
        console.log('ERROR:', error);
        this.loading = false;
      });
    },

    changePartnerRole (userId, role) {
      this.manipulateMemberLoader = true;

      return this.putData(`resources/${this.$route.params.resourceKey}/users/${userId}/role`, {
        role: role.toLowerCase()
      })
      .then(() => {
        this.$refs.partnersTable.getData()
      })
      .catch(error => {
        console.log('change partner role error', error)
      }).finally(() => {
        this.manipulateMemberLoader = false;
        this.showEditRoleModal(false, null, null);
      });
    }
  }

}
</script>
